<template>
  <div id="credit-card-payment">
    <vue-loading :active="isLoading" :is-full-page="true" />
  </div>
</template>

<script>
import VueLoading from 'vue-loading-overlay'
import {paymentService} from "@/services/api/paymentService";
import {PaymentProviders} from "@/constants/constants";

export default {
  data() {
    return {
      isLoading: false,
      externalUrl: ""
    }
  },
  methods: {
    async startCheckout() {
      try {
        this.isLoading = true;
        const response = await paymentService.initPayment(PaymentProviders.PAYONE);
        this.externalUrl = response.redirectURL;
        this.openExternalUrl();
        this.isLoading = false
      } catch (error) {
        console.error(error);
        alert("Error occurred. Look at console for details");
      }
    },
    openExternalUrl() {
      if (this.externalUrl) {
        window.open(this.externalUrl, '_self');
      }
    },
  },
  components: {
    VueLoading,
  },
  async mounted() {
    await this.startCheckout();
  }
}
</script>
